export const TYPES = {
  aggregate_offer: 'AggregateOffer',
  aggregate_rating: 'AggregateRating',
  answer: 'Answer',
  article: 'Article',
  audience: 'Audience',
  blog_posting: 'BlogPosting',
  breadcrumb_list: 'BreadcrumbList',
  contact_point: 'ContactPoint',
  country: 'Country',
  creative_work: 'CreativeWork',
  defined_region: 'DefinedRegion',
  entry_point: 'EntryPoint',
  how_to: 'HowTo',
  how_to_direction: 'HowToDirection',
  how_to_section: 'HowToSection',
  how_to_step: 'HowToStep',
  how_to_supply: 'HowToSupply',
  how_to_tool: 'HowToTool',
  image_object: 'ImageObject',
  item_list: 'ItemList',
  list_item: 'ListItem',
  news_article: 'NewsArticle',
  merchant_return_policy: 'MerchantReturnPolicy',
  merchant_return_policy_seasonal_override: 'MerchantReturnPolicySeasonalOverride',
  monetary_amount: 'MonetaryAmount',
  offer: 'Offer',
  offer_shipping_details: 'OfferShippingDetails',
  opening_hours_specification: 'OpeningHoursSpecification',
  organization: 'Organization',
  brand: 'Brand',
  postal_address: 'PostalAddress',
  question: 'Question',
  thing: 'Thing',
  unit_price_specification: 'UnitPriceSpecification',
  page: {
    about: 'AboutPage',
    contact: 'ContactPage',
    collection: 'CollectionPage',
    item: 'ItemPage',
    web: 'WebPage',
  },
  peopleAudience: 'PeopleAudience',
  person: 'Person',
  product: 'Product',
  rating: 'Rating',
  review: 'Review',
  speakable_specification: 'SpeakableSpecification',
  tech_article: 'TechArticle',
  video_object: 'VideoObject',
  web_site: 'WebSite',
  view_action: 'ViewAction',
  quantitativeValue: 'QuantitativeValue',
  shipping_delivery_time: 'ShippingDeliveryTime',
  size_specification: 'SizeSpecification',
  product_group: 'ProductGroup',
  review_aspect: 'ReviewAspect',
  comment: 'Comment',
  communicate_action: 'CommunicateAction',
  property_value: 'PropertyValue',
};

export const SHIPPING_UNIT_CODES = {
  DAY: 'DAY',
  HUR: 'HUR',
  MIN: 'MIN',
};

export const DATA_POINTS = {
  contact: {
    email: 'support@birchliving.com',
    telephone: '+1-917-540-5525',
    textTelephone: '+1-833-217-3525',
    liveChatHours: '10am - 10pm ET, Monday to Sunday',
    emailResponseTime: 'Typical response time: 2-3 business days',
    textInstructions: 'Text BIRCH to +1-833-217-3525.',
    phoneHours: '10am - 6pm ET, Monday to Friday',
    languages: ['English'],
    customerService: {
      type: 'customer service',
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '10:00',
      closes: '18:00',
    },
    liveChat: {
      type: 'live chat support',
      days: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],
      opens: '10:00',
      closes: '22:00',
    },
    textSupport: {
      type: 'text support',
    },
    areaServed: ['US'],
  },

  image: {
    logo: 'https://birchliving.com/logo-birch.svg',
    logoWidth: 200,
    logoHeight: 80,
    schemaLogoWidth: 600,
    schemaLogoHeight: 60,
  },

  locale: {
    language: 'en-US',
    currency: 'USD',
  },

  name: 'Birch',
  legalName: 'Brooklyn Bedding, LLC d/b/a Birch Living',
  copyrightHolder: 'Brooklyn Bedding LLC',
  alternateName: 'Birch',
  slogan: "A More Natural Night's Sleep",

  description:
    "Birch is committed to using organic and natural materials that pass rigorous testing and achieve the highest ratings and standards. Their mattresses are GREENGUARD Gold and GOLS-certified, and offer better materials - like organic cotton, organic latex, and organic wool - for your best night's sleep.",

  foundingDate: '2019',
  website: {
    about: 'Organic Mattresses & Bedding',
    keywords: [
      'organic mattress',
      'natural mattress',
      'eco-friendly mattress',
      'sustainable bedding',
    ],
    audience: {
      audienceType: 'Consumers',
      geographicArea: 'United States',
    },
    viewCartActionName: 'View Shopping Cart',
    homeName: 'Home',
  },

  founders: [
    {
      name: 'Adam Tishman',
      title: 'Co-Founder',
    },
    {
      name: 'Jerry Lin',
      title: 'Co-Founder',
    },
    {
      name: 'Kristian von Rickenbach',
      title: 'Co-Founder',
    },
  ],

  markets: [
    {
      name: 'United States',
      code: 'US',
    },
    {
      name: 'Canada',
      code: 'CA',
    },
  ],

  shipping: {
    currency: 'USD',
    country: {
      US: 'US',
      CA: 'CA',
    },
    cutoffTime: '14:00:00Z',
    businessDays: [
      'https://schema.org/Monday',
      'https://schema.org/Tuesday',
      'https://schema.org/Wednesday',
      'https://schema.org/Thursday',
      'https://schema.org/Friday',
    ],
    defaults: {
      freeStandard: {
        label: 'Free Standard Delivery',
        cost: 0,
        handlingMin: 0,
        handlingMax: 1,
        transitMin: 3,
        transitMax: 7,
      },
      paidStandard: {
        label: 'Standard Delivery',
        cost: 3.99,
        handlingMin: 0,
        handlingMax: 1,
        transitMin: 2,
        transitMax: 5,
      },
      express: {
        label: 'Express Shipping',
        cost: 14.99,
        handlingMin: 0,
        handlingMax: 0,
        transitMin: 1,
        transitMax: 2,
      },
      sameDay: {
        label: 'Same-Day Delivery',
        cost: 19.99,
        handlingMin: 0,
        handlingMax: 0,
        transitMin: 0,
        transitMax: 0,
      },
      international: {
        label: 'International Shipping',
        cost: 29.99,
        handlingMin: 1,
        handlingMax: 2,
        transitMin: 5,
        transitMax: 14,
      },
    },
  },

  aggregateRating: {
    ratingValue: '4.4',
    reviewCount: '9456',
    bestRating: '5',
    worstRating: '1',
  },


  awards: [
    "Wired's Best Organic Mattress of 2026",
    'The Strategist Best Eco-Friendly Mattress 2025',
    'Health Best Overall Mattress in 2025',
    'NapLab Best Organic Mattress in 2025',
  ],

  credentials: [
    {
      name: 'GOTS Certified (Global Organic Textile Standard)',
      category: 'Organic Textile Certification',
      issuer: 'Global Organic Textile Standard',
    },
    {
      name: 'GOLS Certified (Global Organic Latex Standard)',
      category: 'Organic Latex Certification',
      issuer: 'Global Organic Latex Standard',
    },
    {
      name: 'GREENGUARD Gold Certified',
      category: 'Low Chemical Emissions Certification',
      issuer: 'UL Solutions',
    },
  ],

  parentOrg: {
    name: '3Z Brands',
    url: 'https://3zbrands.com',
  },

  address: {
    streetAddress: '5301 W Bethany Home Rd',
    addressLocality: 'Glendale',
    addressRegion: 'AZ',
    postalCode: '85301',
    addressCountry: 'US',
  },

  url: {
    article: 'https://birchliving.com/articles',
    base: 'https://birchliving.com',
    cart: 'https://birchliving.com/cart',
    collection: 'https://birchliving.com/collections',
    contact_us: 'https://support.birchliving.com',
    page: 'https://birchliving.com/pages',
    product: 'https://birchliving.com/products',
    return_link: 'https://birchliving.com/pages/better-with-birch',
    social: {
      facebook: 'https://www.facebook.com/livebirch/',
      linkedin: 'https://www.linkedin.com/company/3z-brands/',
      instagram: 'https://instagram.com/livebirch',
      x: 'https://twitter.com/LiveBirch',
      youtube: 'https://www.youtube.com/channel/UCKu1aTkrC7VWT3NHm6STBBQ',
    },
    terms_of_use: 'https://birchliving.com/pages/terms',
  },

  returns: {
    mattress: {
      returnDays: 120,
      pickupFee: 99,
    },
    standard: {
      returnDays: 30,
    },
    seasonal: {
      defaultDays: 60,
      startDate: '2026-11-25',
      endDate: '2027-01-15',
    },
    // Map Shopify productType values to their policy.
    // To add a new product type: add its productType string here.
    // Values must match one of: 'mattress' | 'standard'
    productTypePolicies: {
      mattress: 'mattress',
    },
  },
};

export const SCHEMA_ORG = {
  inStock: 'https://schema.org/InStock',
  outOfStock: 'https://schema.org/OutOfStock',
  newCondition: 'https://schema.org/NewCondition',
  salePrice: 'https://schema.org/SalePrice',
  listPrice: 'https://schema.org/ListPrice',
  finite: 'https://schema.org/MerchantReturnFiniteReturnWindow',
  notPermitted: 'https://schema.org/MerchantReturnNotPermitted',
  byMail: 'https://schema.org/ReturnByMail',
  inStore: 'https://schema.org/ReturnInStore',
  free: 'https://schema.org/FreeReturn',
  returnFeesCustomerResponsibility: 'https://schema.org/ReturnFeesCustomerResponsibility',
  shippingFees: 'https://schema.org/ReturnShippingFees',
  full: 'https://schema.org/FullRefund',
  exchange: 'https://schema.org/ExchangeRefund',
  itemListUnordered: 'https://schema.org/ItemListUnordered',
  itemListOrderAscending: 'https://schema.org/ItemListOrderAscending',
  itemListOrderDescending: 'https://schema.org/ItemListOrderDescending',
};

export const IMAGE_DEFAULTS = {
  product: { width: 800, height: 800 },
  article: { width: 1200, height: 630 },
  collection: { width: 1200, height: 800 },
};

export const sellerProperty = {
  seller: {
    '@type': 'Organization',
    '@id': `${DATA_POINTS.url.base}/#organization`,
  },
};

export const acceptedPaymentMethods = [
  'https://schema.org/CreditCard',
  'https://schema.org/DebitCard',
];

export const PEOPLE_AUDIENCE = {
  '@type': TYPES.peopleAudience,
  suggestedGender: 'Unisex',
};
